import { parse, isBefore } from 'date-fns';
import { sessionStorage as createSessionStorage } from '@medflex/utils/browserStorage';
import _ from 'lodash/fp';
import makeApiRequest from '../../../api/makeApiRequest';

export const NAME = 'physicianStatus';
const STORAGE_KEY = 'status';
const storage = createSessionStorage(NAME);

const physicianStatus = {
  name: NAME,
  state: {},
  reducers: {
    updateStatusVisibility: (state, { physicianUserId, remember, statusDisplayed }) => {
      if (remember) {
        if (!statusDisplayed) storage.remove(STORAGE_KEY);
        else
          storage.set(STORAGE_KEY, {
            ...state,
            [physicianUserId]: Date.now(),
          });
      }

      return {
        ...state,
        [physicianUserId]: {
          ...state[physicianUserId],
          statusDisplayed,
        },
      };
    },
    onLoadStatus: (state, payload) => ({
      ...state,
      ...payload,
    }),
    onStatusChanged: (state, payload) => _.merge(state, payload),
  },
  messageListeners: {
    PHYSICIAN_STATUS_CHANGED({ payload }) {
      this.onStatusChanged(payload);
    },
  },
  effects: dispatch => ({
    loadStatus: async ({ physicianIds }, { oidcSession }) => {
      const statuses = {};
      for (const physicianId of physicianIds) {
        const url = `/physicians/${physicianId}/status`;
        /** @type any */
        const [request] = makeApiRequest(url, oidcSession);
        const { data, error } = await request;
        if (error) {
          dispatch.errors.add({ realm: NAME, type: 'loadStatus', error });
        } else {
          dispatch.errors.remove({ realm: NAME, type: 'loadStatus' });
          const { status, statusSetAt, absence, user } = data.data.attributes;
          const lclPhysicianStatus = storage.get(STORAGE_KEY) || {};
          const statusSeenAt = parse(lclPhysicianStatus[physicianId]);
          const currentStatusSetAt = parse(statusSetAt);
          const statusDisplayed = isBefore(currentStatusSetAt, statusSeenAt);
          statuses[physicianId] = {
            physicianId,
            status,
            statusSetAt,
            statusDisplayed,
            absence,
            user,
          };
        }
      }
      dispatch.physicianStatus.onLoadStatus(statuses);
    },
  }),
};

export default physicianStatus;
